/* Cover My Plate · Terms agreement in the builders (checkout plan, Brian 11/2/2026).
   The Terms tick used to sit in the cart and locked Shop Pay, PayPal and Google Pay until it was ticked.
   It now sits right above each builder's Add to cart button:
     "I agree to the Terms of Service and Product Disclaimer. Magnetic plate covers are for shows and off-road
      use only."  (the lawyer-drafted wording from the old cart box, word for word: don't edit it here)
   (builders whose Add to cart sits in a fixed bottom bar have no room for it, so they only use the sheet below).
   Never pre-ticked: every page load starts unticked. Tapping Add to cart without it opens a short sheet with
   the same wording and an "Agree and add to cart" button, so it costs one tap, not a hunt for the box.
   Agreeing never slows Add to cart down: the builder's own Add to cart runs straight away, and the agreement is
   saved on the cart right after the item lands (keepalive, so it survives the jump to the cart page).
   When the shopper agrees, the cart gets the same three attributes the cart box used to save, which land on
   the order and feed the Agreements log in Proof Hub:
     Terms accepted = Yes, Terms version = <version>, Terms accepted at = ISO time from the browser
   plus "Terms agreed in" = Design builder. The cart itself now shows a plain notice (sections/cmp-cart-terms).
   Builders covered: custom/vanity/frames/mini/bike/keychains/signs (data-cxc-add), social covers (data-csb-add),
   social frames (data-csf-add), Japanese plates (data-cxj-add). Loaded on product pages from sections/cmp-seo.liquid. */
(function() {
 'use strict';
 if (window.__cmpConsent) return;
 window.__cmpConsent = true;
 var cfg = window.CMPConsent || {};
 var TOS = cfg.tos || '/policies/terms-of-service';
 var DISC = cfg.disclaimer || '/pages/disclaimer';
 var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
 /* The Terms version lives in one place: the cart page's "Checkout agreement" section (theme editor). Read it
    from there, so the builders and the cart can never disagree. */
 var TV = cfg.version || '2026-10-15';
 var tvReady = null;
 function version() { // read once, as soon as a builder is on the page, so saving never has to wait for it
  if (!tvReady) tvReady = fetch(ROOT + 'cart?sections=terms', { headers: { 'X-CMP': '1' } }).then(function(r) { return r.json(); }).then(function(d) {
   var m = /data-cmpt-version="([^"]+)"/.exec((d && d.terms) || '');
   if (m) TV = m[1];
  }).catch(function() {});
  return tvReady;
 }
 var SEL = '[data-cxc-add],[data-csb-add],[data-csf-add],[data-cxj-add]';
 var agreed = false, saving = null, saved = false, n = 0;
 var TEXT = 'I agree to the <a href="' + TOS + '" target="_blank" rel="noopener">Terms of Service</a> and <a href="' + DISC + '" target="_blank" rel="noopener">Product Disclaimer</a>. Magnetic plate covers are for shows and off-road use only.';

 function css() {
  if (document.getElementById('cmpc-css')) return;
  var s = document.createElement('style');
  s.id = 'cmpc-css';
  s.textContent =
   '.cmpc{display:grid;grid-template-columns:22px minmax(0,1fr);gap:10px;align-items:start;margin:0 0 12px;padding:12px;border-radius:10px;box-shadow:inset 0 0 0 1px var(--cx-line,rgba(127,127,127,.28));cursor:pointer;font:400 13.5px/1.45 var(--cx-font,inherit);color:inherit;text-align:left;transition:box-shadow .2s}' +
   '.cmpc input{width:20px;height:20px;margin:1px 0 0;accent-color:var(--cx-lava,#CFF516);cursor:pointer}' +
   '.cmpc a{color:inherit;text-decoration:underline;text-underline-offset:3px}' +
   '.cmpc.is-flag{box-shadow:inset 0 0 0 1.5px #ff8a7a}' +
   '.cmpc-sheet{position:fixed;inset:0;z-index:2147483001;display:flex;align-items:flex-end;justify-content:center;background:rgba(10,11,13,.55)}' +
   '.cmpc-sheet__box{width:min(460px,100%);margin:0 auto;padding:20px 18px calc(18px + env(safe-area-inset-bottom,0px));border-radius:16px 16px 0 0;background:#16171a;color:#f4f4f2;font:400 15px/1.5 var(--cx-font,Arial,Helvetica,sans-serif);box-shadow:0 -8px 32px rgba(0,0,0,.35)}' +
   '.cmpc-sheet__h{margin:0 0 8px;font-weight:700;font-size:18px;line-height:1.3}' +
   '.cmpc-sheet__p{margin:0 0 16px;color:#d4d5d8}.cmpc-sheet__p a{color:inherit;text-decoration:underline;text-underline-offset:3px}' +
   '.cmpc-sheet__go{display:block;width:100%;min-height:52px;border:0;border-radius:10px;background:var(--cx-lava,#CFF516);color:#111214;font:700 16px/1 var(--cx-font,Arial,Helvetica,sans-serif);cursor:pointer}' +
   '.cmpc-sheet__no{display:block;width:100%;margin-top:6px;min-height:44px;border:0;background:none;color:#9ea3a8;font:500 14px/1 var(--cx-font,Arial,Helvetica,sans-serif);cursor:pointer}' +
   '.cmpc-sheet button:focus-visible,.cmpc input:focus-visible{outline:2px solid var(--cx-lava,#CFF516);outline-offset:2px}' +
   '@media (min-width:700px){.cmpc-sheet{align-items:center}.cmpc-sheet__box{border-radius:16px}}' +
   '@media (prefers-reduced-motion:reduce){.cmpc{transition:none}}';
  document.head.appendChild(s);
 }

 /* Saves the agreement on the cart. Same three attributes as the old cart box, so the Agreements log keeps working.
    Runs after the item is in the cart (see the fetch hook below), never before it. */
 var agreedAt = null;
 function save() {
  if (saving) return saving;
  saving = fetch(ROOT + 'cart/update.js', {
   method: 'POST',
   keepalive: true,
   headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-CMP': '1', 'X-CMP-Guard': '1' },
   body: JSON.stringify({ attributes: { 'Terms accepted': 'Yes', 'Terms version': TV, 'Terms accepted at': agreedAt || new Date().toISOString(), 'Terms agreed in': 'Design builder' } })
  }).then(function(r) { return r.ok; }).catch(function() { return false; });
  saving.then(function(ok) { saved = ok; if (!ok) saving = null; }); // try again on the next add if it didn't stick
  return saving;
 }
 // When a builder's Add to cart lands, save the agreement on that cart.
 var prevFetch = window.fetch;
 window.fetch = function(resource, init) {
  var p = prevFetch.apply(this, arguments);
  try {
   var url = typeof resource === 'string' ? resource : resource && resource.url;
   if (agreed && url && /\/cart\/add(\.js)?(\?|$)/.test(url) && init && String(init.method || '').toUpperCase() === 'POST') {
    p.then(function(r) { if (r.ok && agreed) save(); }, function() {});
   }
  } catch (e) {}
  return p;
 };

 function boxes() { return document.querySelectorAll('.cmpc input'); }
 function setAgreed(on) {
  agreed = on;
  agreedAt = on ? new Date().toISOString() : null;
  Array.prototype.forEach.call(boxes(), function(b) { b.checked = on; b.closest('.cmpc').classList.remove('is-flag'); });
 }

 /* Buttons in a fixed or sticky bar (the studio builders' bottom bar) get no row: there's no room. They use the sheet. */
 function pinned(el) {
  for (var e = el.parentElement; e && e !== document.body; e = e.parentElement) {
   var p = getComputedStyle(e).position;
   if (p === 'fixed' || p === 'sticky') return true;
  }
  return false;
 }
 /* One tick row above each builder's main Add to cart button (not the sticky bar copies). */
 function place() {
  var btns = document.querySelectorAll(SEL);
  Array.prototype.forEach.call(btns, function(btn) {
   version();
   var v = btn.getAttribute('data-csb-add') || btn.getAttribute('data-csf-add') || '';
   if (v === 'bar' || v === 'sticky' || btn.__cmpc || pinned(btn)) return;
   var prev = btn.previousElementSibling;
   if (prev && prev.classList && prev.classList.contains('cmpc')) { btn.__cmpc = true; return; }
   css();
   btn.__cmpc = true;
   var id = 'cmpc-' + (++n);
   var row = document.createElement('label');
   row.className = 'cmpc';
   row.setAttribute('for', id);
   row.innerHTML = '<input type="checkbox" id="' + id + '" autocomplete="off"><span>' + TEXT + '</span>';
   var input = row.querySelector('input');
   input.checked = agreed;
   input.addEventListener('change', function() { setAgreed(input.checked); });
   btn.parentNode.insertBefore(row, btn);
  });
 }

 var sheet = null, pendingBtn = null, lastFocus = null;
 function openSheet(btn) {
  css();
  pendingBtn = btn;
  lastFocus = document.activeElement;
  if (!sheet) {
   sheet = document.createElement('div');
   sheet.className = 'cmpc-sheet';
   sheet.innerHTML = '<div class="cmpc-sheet__box" role="dialog" aria-modal="true" aria-labelledby="cmpc-h">' +
    '<p class="cmpc-sheet__h" id="cmpc-h">One last thing</p>' +
    '<p class="cmpc-sheet__p">' + TEXT + '</p>' +
    '<button type="button" class="cmpc-sheet__go">Agree and add to cart</button>' +
    '<button type="button" class="cmpc-sheet__no">Not yet</button></div>';
   sheet.addEventListener('click', function(e) { if (e.target === sheet) closeSheet(false); });
   sheet.querySelector('.cmpc-sheet__go').addEventListener('click', function() { closeSheet(true); });
   sheet.querySelector('.cmpc-sheet__no').addEventListener('click', function() { closeSheet(false); });
   sheet.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeSheet(false);
    if (e.key === 'Tab') { // keep focus inside the two buttons
     var b = sheet.querySelectorAll('button'), first = b[0], last = b[b.length - 1];
     if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
     else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
   });
  }
  document.body.appendChild(sheet);
  sheet.querySelector('.cmpc-sheet__go').focus();
 }
 function closeSheet(yes) {
  if (!sheet || !sheet.parentNode) return;
  sheet.parentNode.removeChild(sheet);
  var btn = pendingBtn;
  pendingBtn = null;
  if (yes) {
   setAgreed(true);
   go(btn);
  } else {
   Array.prototype.forEach.call(boxes(), function(b) { b.closest('.cmpc').classList.add('is-flag'); });
   if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch (x) {}
  }
 }
 /* Let the builder's own Add to cart run straight away. */
 function go(btn) {
  if (!btn) return;
  btn.__cmpcPass = true;
  btn.click();
  btn.__cmpcPass = false;
 }

 document.addEventListener('click', function(e) {
  var btn = e.target && e.target.closest && e.target.closest(SEL);
  if (!btn || btn.__cmpcPass || btn.disabled) return;
  if (btn.classList.contains('is-next')) return; // the studio builders' button says "Next: ..." until the last step
  if (agreed) return; // agreed: carry on as normal (saved once the item lands)
  e.preventDefault();
  e.stopImmediatePropagation();
  openSheet(btn);
 }, true);

 // a page restored with Back starts unticked too
 window.addEventListener('pageshow', function(e) { if (e.persisted) { agreed = false; saving = null; saved = false; Array.prototype.forEach.call(boxes(), function(b) { b.checked = false; }); } });

 function start() {
  place();
  if (!window.MutationObserver) return;
  var t = null;
  new MutationObserver(function() { clearTimeout(t); t = setTimeout(place, 120); }).observe(document.body, { childList: true, subtree: true });
 }
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
 else start();
})();
